export interface AppState {
  init: boolean
  language: string
  status: MetaDataStatus | null
  isMobileDevice: boolean
  browserMapPosition: {
    lat: number
    lng: number
  }
  browserMapHeaders: {
    country: string
    city: string
  }
  unit: string
}

export enum MetaDataStatus {
  success = 'success',
  error = 'error',
  pending = 'pending',
}
